import LEAD_TYPES from './constants/LeadTypes.js';
import LeadSubmissionBuilder from './services/LeadSubmissionBuilder.js';

const version = process.env.VERSION;

export { LeadSubmissionBuilder, LEAD_TYPES, version };

export default {
    LeadSubmissionBuilder,
    LEAD_TYPES,
    version,
};



// WEBPACK FOOTER //
// ../widget-commons-leads/src/index.js